import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwComponent, DwComponentType, DwExpressionService, DwFormContextMode, DwGridActionKeys, DwGridEvent, DwGridEvents, DwGridHeightMode, DwMdFormContextInfo, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataGridComponent, DwMetaDataGridPreferences, DwMetaDataGridViewPreference, DwMetaDataService, DwMetaDataServiceToken, DwMetadataFormUtilService, DwModalConfig, DwModalHandler, DwModalResult, DwRelationshipInfo, DwSectionBaseComponent, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, areEqual, deepCopy, removeNullProperties } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { debounceTime, mergeMap } from 'rxjs/operators';
import { map } from 'underscore';
import { AppMetaDataLookups, AppMetaDataItemNames, PlanOfActionEntity, PilotExaminerEntity, AcsTestEntity, PlanOfActionSectionEntity, AppMetaData, PlanOfActionSectionTypeAllItems, AcsCodeEntity, ApplicantAcsWrittenResultEntity, CheckRideRequestEntity, FlightSchoolApplicantEntity, CheckRideExaminerTypeAllItems, CheckRideApplicantTypeAllItems, FlightSchoolTypeAllItems, CheckRideOwnershipTypeAllItems, CheckRideInstructorTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { PlanOfActionRepositoryService } from '../../../plan-of-action/services/plan-of-action-repository.service';
import { AcsCodeStatuses } from '../../../plan-of-action/models/acs-code-items.model';
import { DwMdGridCallbacks } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/callbacks/dw-md-grid-callbacks.interface';
import { PlanOfActionUtilService } from '../../services/plan-of-action-util.service';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { PilexosUserTypeIds } from '../../../shared/models/pilexos-user-type.enum';

@DwComponent({
  key: 'plan-of-action-util',
  name: 'Plan of Action Util',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.PlanOfAction
})
@Component({
  selector: 'app-plan-of-action-util',
  templateUrl: './plan-of-action-util.component.html',
  styleUrls: ['./plan-of-action-util.component.scss']
})
export class PlanOfActionUtilComponent extends DwSectionBaseComponent {
  formApi: DwMetaDataFormApi;
  schoolFeatures: import("c:/Projects/DevwareGit/Pilexos/PilexosCAPAngular/src/app/features/schools/models/school-features.model").SchoolFeatures;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private dwMetaDataFormUtilService: DwMetadataFormUtilService,
    private planOfActionRepositoryService: PlanOfActionRepositoryService,
    private planOfActionUtil: PlanOfActionUtilService,
    private schoolRepositoryService: SchoolRepositoryService,
    private adminManagerService: AdminManagerService,
    private dateTimeUtilService: DateTimeUtilService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.loadReferenceData();
    this.formApi.getFormDataChanges(100)
      .subscribe(dataChange => {
        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      });
  }

  referenceDataLoaded: boolean = false;
  loadReferenceData() {
    this.schoolRepositoryService.getSchoolFeatures().subscribe(features => {
      this.schoolFeatures = features;

      this.referenceDataLoaded = true;

      this.checkForDataChange();
    });
  }

  lastPlanOfAction: PlanOfActionEntity;

  checkForDataChange() {
    if (!this.referenceDataLoaded) {
      return;
    }

    const planOfAction = this.formApi.getFormData<PlanOfActionEntity>();

    if (this.lastPlanOfAction && planOfAction.FlightSchoolApplicantId != this.lastPlanOfAction.FlightSchoolApplicantId) {
      this.handleApplicantChange(planOfAction);
    }

    this.setDefaults();

    this.lastPlanOfAction = deepCopy(planOfAction);
  }

  defaultsSet: boolean = false;
  setDefaults() {

    if (this.defaultsSet) {
      return;
    }

    this.defaultsSet = true;
    const planOfAction = this.formApi.getFormData<PlanOfActionEntity>();

    // Only set defaults on initial add, not on edit
    if (this.formApi.formMode != DwFormContextMode.add) {
      return;
    }

    const pilexosUser = this.adminManagerService.getPilexosUser();

    const planOfActionUpdate: Partial<PlanOfActionEntity> = {};

    switch(pilexosUser.UserTypeId) {
      case PilexosUserTypeIds.pilotExaminer:
        planOfActionUpdate.CheckRideOwnershipTypeId = CheckRideOwnershipTypeAllItems.Examiner;
        planOfActionUpdate.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.Examiner;
        planOfActionUpdate.CheckRideApplicantTypeId = CheckRideApplicantTypeAllItems.ManualEntry;
        planOfActionUpdate.CheckRideInstructorTypeId = CheckRideApplicantTypeAllItems.ManualEntry;
        break;
      case PilexosUserTypeIds.flightSchool:
      case PilexosUserTypeIds.checkInstructor:
      case PilexosUserTypeIds.flightInstructor:
        planOfActionUpdate.CheckRideOwnershipTypeId = CheckRideOwnershipTypeAllItems.FlightSchool;
        planOfActionUpdate.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.FlightSchoolExaminer;
        planOfActionUpdate.CheckRideApplicantTypeId = CheckRideApplicantTypeAllItems.FlightSchoolStudent;
        planOfActionUpdate.FlightSchoolTypeId = this.schoolFeatures?.FlightSchoolTypeId || FlightSchoolTypeAllItems.Standard;
        
        if (this.schoolFeatures?.FlightSchoolTypeId == FlightSchoolTypeAllItems.ODA) {
          planOfActionUpdate.CheckRideInstructorTypeId = CheckRideInstructorTypeAllItems.ManualInstructor;
        } else {
          planOfActionUpdate.CheckRideInstructorTypeId = CheckRideInstructorTypeAllItems.FlightSchoolInstructor;
        }
        break;
    }

    this.formApi.patchFormData(planOfActionUpdate);
  }


  handleApplicantChange(planOfAction: PlanOfActionEntity) {
    this.schoolRepositoryService.getFlightSchoolApplicant(planOfAction.FlightSchoolApplicantId, false, true)
      .subscribe(applicant => {
        const planOfActionUpdate = this.updatePlanOfActionApplicantData(planOfAction, applicant, false);

        this.formApi.patchFormData(planOfActionUpdate);
      });
  }

  updatePlanOfActionApplicantData(
    planOfAction: PlanOfActionEntity,
    applicant: FlightSchoolApplicantEntity,
    removeNullPropertiesOption: boolean = true
  ): Partial<PlanOfActionEntity> {
    let planOfActionUpdate: Partial<PlanOfActionEntity> = {
      // ——— 1) DIRECT / SAFE COPIES (same meaning, clear intent) ———
      FlightSchoolApplicantId: applicant.FlightSchoolApplicantId,
      FlightSchoolOrganizationId: applicant.FlightSchoolOrganizationId,
      CheckRideGroupId: applicant.CheckRideGroupId,
      CheckRideTypeId: applicant.CheckRideTypeId,
      CheckRideTestTypeId: applicant.CheckRideTestTypeId,
      FlightSchoolInstructorId: applicant.PrimaryFlightSchoolInstructorId,

      AuthorityPreCheckRideNumber: applicant.AuthorityPreCheckRideNumber,
      PilotCertificateNumber: applicant.PilotCertificateNumber,
      StudentApplicantStateProvinceId: applicant.StateProvinceId,
      ForeignPilotMeetsQualifications: applicant.ForeignPilotMeetsQualifications,
      AuthorityApplicationNumber: applicant.AuthorityApplicationNumber,
      ApplicantAcsWrittenResultId: applicant.ApplicantAcsWrittenResultId,

      // Citizenship mapping
      StudentApplicantCitizenshipCountryId: applicant.CitizenshipCountryId,

      // Optional checkride-related defaults
      //CheckrideDateTime: planOfAction.CheckrideDateTime || applicant.ExpectedCheckrideDateTime,
    };

    if (applicant.FlightSchoolApplicantBranch?.length > 0) {
      const location = applicant.FlightSchoolApplicantBranch[0];

      if (location?.FlightSchoolBranch?.MainAirportId) {
        planOfActionUpdate.CheckRideAirportId = location.FlightSchoolBranch.MainAirportId;
      }
    }

    if (applicant.FlightSchoolBranch?.MainAirportId) {
      planOfActionUpdate.CheckRideAirportId = applicant.FlightSchoolBranch.MainAirportId;
    }

    planOfActionUpdate.PrimaryTraningAirportId = planOfActionUpdate.CheckRideAirportId;

    if (this.dateTimeUtilService.isTodayOrAfter(applicant.ExpectedCheckrideDateTime)) {
      planOfActionUpdate.CheckrideDateTime = applicant.ExpectedCheckrideDateTime;
    }

    if (removeNullPropertiesOption) {
      planOfActionUpdate = removeNullProperties(planOfActionUpdate);
    }

    return planOfActionUpdate;
  }



}
